import {
  Button,
  JoonUIColor,
  Modal,
  ModalHeader,
  TextButton,
  Typography,
} from "@joonapp/web-shared"
import { create } from "zustand"

import useScheduledMessageModalStore from "./useScheduledMessageModalStore"
import { useDeleteScheduledMessageMutation } from "../../../networking/scheduledMessages/mutations"

interface DeleteScheduledMessageModalStore {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

export const useDeleteScheduledMessageModalStore =
  create<DeleteScheduledMessageModalStore>((set) => ({
    isOpen: false,
    onOpen: () => set({ isOpen: true }),
    onClose: () => set({ isOpen: false }),
  }))

const DeleteScheduledMessageModal = () => {
  const { isOpen, onClose: closeDeleteModal } =
    useDeleteScheduledMessageModalStore()
  const { scheduledMessageId, onClose: closeScheduledMessageModal } =
    useScheduledMessageModalStore()

  const { mutateAsync: deleteScheduledMessage, isLoading } =
    useDeleteScheduledMessageMutation()

  const handleDelete = async () => {
    if (!scheduledMessageId) return
    await deleteScheduledMessage({ messageId: scheduledMessageId })
    closeDeleteModal()
    closeScheduledMessageModal()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={closeDeleteModal}
      className="w-[400px] max-w-[95vw]"
    >
      <ModalHeader
        title="Confirm deletion"
        onClose={closeDeleteModal}
        showBorderBottom
      />
      <div className="flex flex-col gap-6 p-6 pt-4">
        <Typography variant="body">
          Are you sure? Once deleted, you won't be able to see this message
          anymore.
        </Typography>
        <div className="flex flex-row gap-4 items-center justify-end">
          <TextButton onClick={closeDeleteModal}>
            <Typography variant="body" color={JoonUIColor.text.primaryAccent}>
              No, cancel
            </Typography>
          </TextButton>
          <Button
            text="Yes, delete"
            onClick={handleDelete}
            isLoading={isLoading}
            buttonType="redPrimary"
          />
        </div>
      </div>
    </Modal>
  )
}

export default DeleteScheduledMessageModal
